import * as PIXI from 'pixi.js';
import { Entity } from '../core/EntityManager';

export class PhishingTrap extends Entity {
  private graphics: PIXI.Graphics;
  private warningGraphic: PIXI.Graphics;
  private lifetime = 8000;
  private elapsed = 0;
  private activeTrap = true;

  constructor() {
    super();
    this.radius = 16;

    // Trap looks like a bonus (coin-like)
    this.graphics = new PIXI.Graphics();
    this.graphics.circle(0, 0, 12);
    this.graphics.fill(0x4444ff);
    this.graphics.circle(0, 0, 8);
    this.graphics.fill(0x6666ff);
    // Exclamation mark
    this.graphics.rect(-1, -6, 2, 6);
    this.graphics.fill(0xffffff);
    this.graphics.circle(0, 2, 1.5);
    this.graphics.fill(0xffffff);
    this.sprite.addChild(this.graphics);

    // Warning indicator (red ring)
    this.warningGraphic = new PIXI.Graphics();
    this.warningGraphic.circle(0, 0, 16);
    this.warningGraphic.stroke({ color: 0xff0000, width: 2, alpha: 0.6 });
    this.sprite.addChild(this.warningGraphic);
  }

  update(dt: number, _tick: number): void {
    this.elapsed += dt * 1000;

    // Pulse warning ring
    const pulse = Math.sin(this.elapsed / 200) * 0.3 + 0.7;
    this.warningGraphic.alpha = pulse;

    // Fade out near end
    if (this.elapsed > this.lifetime * 0.7) {
      const fadeProgress = (this.elapsed - this.lifetime * 0.7) / (this.lifetime * 0.3);
      this.sprite.alpha = 1 - fadeProgress;
    }

    // Expire
    if (this.elapsed >= this.lifetime) {
      this.activeTrap = false;
      this.active = false;
      this.sprite.visible = false;
    }
  }

  isActive(): boolean {
    return this.activeTrap && this.active;
  }
}
